module.exports = __webpack_public_path__ + "media/images/eye-regular 1-3fc1f645.svg";